/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-14 12:21:22
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-18 16:18:03
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/ProductDetail/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import Title from './Components/TitlePart';
import Option from './Components/OptionPart';
import Field from './Components/FieldPart';
import { useSelector, useDispatch } from 'react-redux';
import {
  getProductDetailOrder,
  getProductDetailData,
  EnumCollapseId,
  onProductDetailChange,
  ActionType,
} from '../slice';
import { useChangeFunctions } from './tools';
import SectionHOC from '../HOC';
import { StyledTitle } from 'src/layout/EditorPageLayout/SectionTitle';
import { EnumServiceType } from 'src/types/common/product';
import { generateErrorKey, getError } from 'src/tools/helper';
import { Button } from 'src/components/Antd';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ProductDetail = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;

  const _d = useDispatch();
  const order = useSelector(getProductDetailOrder()) || [];
  const onDetailAdd = () => {
    _d(
      onProductDetailChange({
        type: ActionType.add,
      }),
    );
  };
  const isLast = order.length === 1;
  const generator = () => {
    return order.map((i, index) => {
      const funcs = useChangeFunctions({ detailUuid: i, dispatch: _d });

      return (
        <ComposePart
          {...funcs}
          id={i}
          key={i}
          isFirst={!index}
          getContent={getProductDetailData}
          isLast={isLast}
          disabled={disabled}
        />
      );
    });
  };
  return (
    <React.Fragment>
      {generator()}
      <Button onClick={onDetailAdd} className={css.addBtn} disabled={disabled}>
        {getI18n('allProducts.addvirtualproduct.createanotherdetailitem')}
      </Button>
    </React.Fragment>
  );
};
export default SectionHOC(ProductDetail, {
  id: EnumCollapseId.ProductDetail,
  title: (
    <StyledTitle
      left={getI18nFromGeneral('general.hOCTitle.productDetails')}
      leftBottom={getI18nFromGeneral('general.hOCTitle.productDetailsBottom')}
    />
  ),

  useCustomCollapseTitle: true,
  useDefaultCollapseContent: false,
});

const ComposePart = (props) => {
  const {
    getContent,
    id,
    onRequiredChange,
    onFieldTypeChange,
    onTitleChange,
    onDetailDelete,
    //=====
    onOptionChange,
    onMaxSelectionChange,
    onOptionsChange,
    onOptionsSort,
    onOptionsDelete,
    onOptionsAdd,
    //========
    onCharLimitChange,
    onPlaceholderChange,
    //===
    isFirst,
    isLast,
    //==
    disabled,
  } = props;
  const data: any = useSelector(getContent(id)) || {};

  const {
    required,
    fieldType,
    title,
    options,
    optionType,
    maxSelection,
    placeHolder,
    charLimit,
  } = data;
  const _dict = {
    [EnumServiceType.Text]: (
      <Field
        onCharLimitChange={onCharLimitChange}
        onPlaceholderChange={onPlaceholderChange}
        data={{ placeHolder, charLimit }}
        disabled={disabled}
      />
    ),
    [EnumServiceType.Selector]: (
      <Option
        onOptionChange={onOptionChange}
        onMaxSelectionChange={onMaxSelectionChange}
        onOptionsChange={onOptionsChange}
        onOptionsSort={onOptionsSort}
        onOptionsDelete={onOptionsDelete}
        onOptionsAdd={onOptionsAdd}
        data={{ options, optionType, maxSelection }}
        disabled={disabled}
      />
    ),
  };
  return (
    <SectionContent {...(!isFirst ? { className: css.noPaddingTop } : {})}>
      <Title
        disabled={disabled}
        id={id}
        {...(!isLast ? { onDelete: onDetailDelete } : {})}
        onRequiredChange={onRequiredChange}
        onTitleChange={onTitleChange}
        onFieldTypeChange={onFieldTypeChange}
        data={{
          [generateErrorKey('title')]: getError('title', data),
          required,
          fieldType,
          title,
        }}
      />
      {_dict[fieldType]}
    </SectionContent>
  );
};
